import * as React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./i18n.js";
import zoomPlugin from "chartjs-plugin-zoom";
import annotationPlugin from "chartjs-plugin-annotation";
import { ResizeObserver as ResizeObserverPolyfill } from "@juggle/resize-observer"; //for phone support
import { HotkeysProvider, Spinner } from "@blueprintjs/core";

import ActivityReport from "./components/Reports/Activity/ActivityReport";
import CustomReport from "./components/Reports/custom/CustomReport.js";
import FinancialReport from "./components/Reports/Financial/FinancialReport";
import Home from "./components/Home/Home";
import SupervisionMenu from "./components/Supervision/SupervisionMenu.js";
import Supervision from "./components/Supervision/Supervision";
import DeviceSettings from "./components/Supervision/DeviceSettings/DeviceSettings";
import Screenshot from "./components/Supervision/Screenshot";
import { Camera } from "./components/Supervision/Camera";
import NotificationsPage from "./components/Notifications/NotificationsPage";
import Settings from "./components/Settings/Settings";
import EventFiltersSetting from "./components/Supervision/Events/EventFiltersSetting";
import Tarif from "./components/Settings/Tarif/Tarif";
import ALPRDashboard from "./components/Supervision/ALPR/ALPRDashboard.js";
import EventFlow from "./components/Supervision/Events/EventFlow.js";
import Phonie from "./components/Phonie/Phonie.js";
import NotFoundPage from "./components/Structure/NotFoundPage.js";
import Signin, { CheckAuth } from "./components/auth/Signin";
import Navbar from "./components/Structure/navbar/Navbar.js";
import { CertificateManager } from "./components/auth/CertificateManager"
import BonificationPage from "./components/Bonification/BonificationPage";
import AccessCode from "./components/Code/AccessCode.js";
import IRVEMenu from "./components/IRVE/IRVEMenu.js";
import DetectionClassification from "./components/Supervision/DetectionClassification/DetectionClassification.js";
import Bookings from "./components/Resa/Bookings.js";
import ExternalAccessControlPage from "./components/ExternalAccessControl/ExternalAccessControlPage.js";

import './global.scss'

// setup chartJS
import {
  Chart,
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Legend,
  Title,
  Tooltip,
} from "chart.js";

Chart.register(
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Legend,
  Title,
  Tooltip,
  zoomPlugin,
  annotationPlugin
);

if (typeof window !== "undefined") {
  window.ResizeObserver = window.ResizeObserver || ResizeObserverPolyfill;
}

export const front_basename = "/ow/view";

// create the app
ReactDOM.render(
  <React.StrictMode>
    <React.Suspense fallback={<Spinner />}>
      <HotkeysProvider>
        <BrowserRouter basename={front_basename}>
            <Navbar />
              <Routes>
                <Route exact path="/" element={<Home />} />
                <Route exact path="/home" element={<Home />} />
                <Route exact path="/signin" element={<Signin />} />
                <Route exact path="/notifications" element={<NotificationsPage />} />
                <Route exact path="/certs/:route" element={<CertificateManager />} />
                <Route exact path="/screenshot/:srvId/:eqId" element={<Screenshot />} />
                <Route exact path="/camera/:srvId/:eqId" element={<Camera />} />
                <Route exact path="/supervision" element={<SupervisionMenu />} />
                <Route exact path="/supervision/:groupId" element={<Supervision />} />
                <Route exact path="/device/:serverId/:deviceId/settings" element={<DeviceSettings />} />
                <Route exact path="/financial" element={<FinancialReport />} />
                <Route exact path="/activity" element={<ActivityReport />} />
                <Route exact path="/report" element={<CustomReport />} />
                <Route exact path="/phonie" element={<Phonie />} />
                <Route exact path="/bonification" element={<BonificationPage />} />
                <Route exact path="/externAccessControl" element={<ExternalAccessControlPage />} />
                <Route exact path="/settings" element={<Settings />} />
                <Route exact path="/settings/events" element={<EventFiltersSetting />} />
                <Route exact path="/tarif" element={<Tarif />} />
                <Route exact path="/alpr" element={<ALPRDashboard />} />
                <Route exact path="/dc" element={<DetectionClassification />} />
                <Route exact path="/eventflow/:groupId" element={<EventFlow static={true} pageSize={50} enableSearch={true} closable={true}/>} />
                <Route exact path="/code" element={<AccessCode />} />
                <Route exact path="/irve" element={<IRVEMenu />} />
                <Route exact path="/bookings" element={<Bookings />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            <CheckAuth />
        </BrowserRouter>
      </HotkeysProvider>
    </React.Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);
